import styled, { css } from 'styled-components';

const Content = styled.div`
  ${({ isDesktop }) =>
    isDesktop &&
    css`
      padding-top: 2vh;
      margin: 0 1% 0 1%;
    `}
  margin-top: 42px;
  padding-bottom: 3vh;
`;

export default Content;
